import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _noop from 'lodash/noop';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _reduce from 'lodash/reduce';
import { EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import { tget } from '@tekion/tekion-base/utils/general';
import createHTTP from '@tekion/tekion-base/services/apiService';
import { getErrorMessage } from '@tekion/tekion-base/utils/errorUtils';
import { toaster, TOASTER_TYPE } from '../organisms/NotificationWrapper';
import Http from '../widgets/accessHelper/services/http';
var REQUEST_TIMEOUT_LONG = 30000;
var PATH = '/media/w/u/upload';
var GLOBAL_PATH = "".concat(PATH, "/global/RECOMMENDATIONS");
var GET_SIGNED_URL = '/media/r/u/presignedurls';
var GET_SIGNED_URL_V2 = '/media/r/u/v2/presignedurls';
var GET_SIGNED_URL_ALL = '/media/r/u/presignedurls/all';
var GET_FILE_SIGNED_URL = 'api/integration/services/u/repairorder/v1/getPresignedURl';
var GET_SIGNED_THUMBNAIL_URL = 'media/r/u/thumbnail/presignedurls';
var GET_PRESIGNED_URL_BUCKETS = 'sales/settings/u/v1.0.0/sales/presignedurls';
var UPLOAD_TO_MEDIA = 'api/sales/settings/u/v1.0.0/sales/upload-to-media';
/**
 * @param {*} config { baseURL, headers }
 */
export var uploadFiles = function uploadFiles(config) {
  var mediaList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var progressCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _noop;
  var successCb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _noop;
  var failureCb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _noop;
  return function (dispatch) {
    mediaList.forEach(function (media) {
      return dispatch(uploadFile(config, media, progressCb, successCb, failureCb));
    });
  };
};

/**
 * @param {*} config { baseURL, headers }
 * @param {*} media media object to upload. media must have a key called file pointing to file to upload.
 * @param {*} progressCb callback will be called with { media, progress }
 * @param {*} successCb callback will be called on success with { media, key }
 * @param {*} failureCb callback will be called on failure with { media, errorMessage }
 */
export var uploadFile = function uploadFile(config, media) {
  var progressCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _noop;
  var successCb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _noop;
  var failureCb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _noop;
  var isGlobal = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  return function () {
    var baseURL = config.baseURL,
      headers = config.headers,
      _config$params = config.params,
      params = _config$params === void 0 ? EMPTY_OBJECT : _config$params;
    if (!baseURL || !media.file) {
      console.error('Missing file/baseURL which are required for upload');
      return;
    }
    progressCb({
      media: media,
      progress: 0
    });
    var onProgressUpdate = function onProgressUpdate(progressEvent) {
      var progress = progressEvent.loaded / progressEvent.total * 100;
      progressCb({
        media: media,
        progress: progress
      });
    };
    var cancelSource = media.cancelSource;
    var data = new FormData();
    data.append('file', media.file, media.name);
    var axiosConfig = {
      baseURL: baseURL,
      headers: headers,
      params: params,
      onUploadProgress: onProgressUpdate,
      cancelToken: _get(cancelSource, 'token') || EMPTY_STRING
    };
    var path = isGlobal ? GLOBAL_PATH : PATH;
    // eslint-disable-next-line consistent-return
    return createHTTP(baseURL, headers).post(path, data, axiosConfig).then(function (result) {
      var response = _get(result, 'data.data');
      var key = _get(response, 'mediaId');
      if (key) {
        return successCb({
          media: media,
          response: response
        });
      }
      return failureCb({
        media: media,
        errorMessage: ''
      });
    })["catch"](function (error) {
      var errorMessage = getErrorMessage(error, EMPTY_STRING);
      failureCb({
        media: media,
        errorMessage: errorMessage
      });
    });
  };
};
export var getSignedURLs = function getSignedURLs(config) {
  var mediaFilesKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var baseURL, headers, axiosConfig;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          baseURL = config.baseURL, headers = config.headers;
          axiosConfig = {
            baseURL: baseURL,
            headers: headers,
            timeout: REQUEST_TIMEOUT_LONG
          };
          return _context.abrupt("return", createHTTP(baseURL, headers).post(GET_SIGNED_URL, mediaFilesKeys, axiosConfig).then(function (result) {
            var signedURLs = _get(result, 'data.data') || {};
            return {
              data: responseWrapper(signedURLs),
              error: null,
              response: signedURLs
            };
          })["catch"](function (error) {
            var errorMessage = getErrorMessage(error, EMPTY_STRING);
            return {
              data: null,
              error: errorMessage
            };
          }));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};
export var getSignedURLsForV2Service = function getSignedURLsForV2Service(config) {
  var mediaFilesKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var baseURL, headers, axiosConfig;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          baseURL = config.baseURL, headers = config.headers;
          axiosConfig = {
            baseURL: baseURL,
            headers: headers,
            timeout: REQUEST_TIMEOUT_LONG
          };
          return _context2.abrupt("return", createHTTP(baseURL, headers).post(GET_SIGNED_URL_V2, mediaFilesKeys, axiosConfig).then(function (result) {
            var signedURLs = _get(result, 'data.data') || {};
            return {
              data: responseWrapperForV2Service(signedURLs),
              error: null,
              response: signedURLs
            };
          })["catch"](function (error) {
            console.error(error);
            var errorMessage = getErrorMessage(error, EMPTY_STRING);
            return {
              data: null,
              error: errorMessage
            };
          }));
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
};
export var getAllSignedURLs = function getAllSignedURLs(config) {
  var mediaFilesKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var baseURL, headers, axiosConfig, result, signedURLs, errorMessage;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          baseURL = config.baseURL, headers = config.headers;
          axiosConfig = {
            baseURL: baseURL,
            headers: headers,
            timeout: REQUEST_TIMEOUT_LONG
          };
          _context3.prev = 2;
          _context3.next = 5;
          return createHTTP(baseURL, headers).post(GET_SIGNED_URL_ALL, mediaFilesKeys, axiosConfig);
        case 5:
          result = _context3.sent;
          signedURLs = _get(result, 'data.data', EMPTY_OBJECT);
          return _context3.abrupt("return", {
            data: _reduce(signedURLs, function (acc, _ref4) {
              var mediaId = _ref4.mediaId,
                normalUrl = _ref4.normalUrl,
                thumbnailUrl = _ref4.thumbnailUrl;
              return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, mediaId, {
                url: _get(normalUrl, 'normalUrlResponseMap.url'),
                thumbnailUrl: _get(thumbnailUrl, 'thumbnailUrlResponseMap.thumbnaiurl')
              }));
            }, EMPTY_OBJECT),
            error: null,
            response: signedURLs
          });
        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](2);
          errorMessage = getErrorMessage(_context3.t0, EMPTY_STRING);
          return _context3.abrupt("return", {
            data: null,
            error: errorMessage
          });
        case 14:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 10]]);
  }));
};
export var getFileSignedURLs = function getFileSignedURLs(config) {
  var mediaFilesKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var baseURL, headers, axiosConfig;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          baseURL = config.baseURL, headers = config.headers;
          axiosConfig = {
            baseURL: baseURL,
            headers: headers,
            timeout: REQUEST_TIMEOUT_LONG
          };
          return _context4.abrupt("return", createHTTP(baseURL, headers).post(GET_FILE_SIGNED_URL, mediaFilesKeys, axiosConfig).then(function (result) {
            var signedURLs = tget(result, 'data.data') || {};
            return {
              data: signedURLs,
              error: null,
              response: signedURLs
            };
          })["catch"](function (error) {
            var errorMessage = getErrorMessage(error, EMPTY_STRING);
            return Promise.reject(errorMessage);
          }));
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
};
export var getSignedThumbnailURLs = function getSignedThumbnailURLs(config) {
  var mediaFilesKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var baseURL, headers, axiosConfig;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          baseURL = config.baseURL, headers = config.headers;
          axiosConfig = {
            baseURL: baseURL,
            headers: headers,
            timeout: REQUEST_TIMEOUT_LONG
          };
          return _context5.abrupt("return", createHTTP(baseURL, headers).post(GET_SIGNED_THUMBNAIL_URL, mediaFilesKeys, axiosConfig).then(function (result) {
            var signedURLs = _get(result, 'data.data') || {};
            return {
              data: responseWrapper(signedURLs),
              error: null
            };
          })["catch"](function (error) {
            var errorMessage = getErrorMessage(error, EMPTY_STRING);
            return {
              data: null,
              error: errorMessage
            };
          }));
        case 3:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
};
var responseWrapper = function responseWrapper(data) {
  var signedURLs = {};
  if (!_isEmpty(data)) {
    data.forEach(function (value) {
      var mediaId = value.mediaId,
        url = value.responseMap.url;
      if (url) signedURLs[mediaId] = url;
    });
  }
  return signedURLs;
};
var responseWrapperForV2Service = function responseWrapperForV2Service(data) {
  var signedURLs = {};
  if (!_isEmpty(data)) {
    data.forEach(function (value) {
      var mediaId = value.mediaId,
        url = value.normal.url;
      if (url) signedURLs[mediaId] = url;
    });
  }
  return signedURLs;
};
export var responseWrapperV2 = function responseWrapperV2(data) {
  var signedURLs = {};
  if (!_isEmpty(data)) {
    data.forEach(function (value) {
      var mediaId = value.mediaId,
        _value$responseMap = value.responseMap,
        url = _value$responseMap.url,
        contentType = _value$responseMap.contentType;
      if (url) signedURLs[mediaId] = {
        url: url,
        contentType: contentType
      };
    });
  }
  return signedURLs;
};
var generatePresignedURLAfterUpload = function generatePresignedURLAfterUpload(successCb, failureCb, media, _ref7) {
  var _media$bucket;
  var baseURL = _ref7.baseURL,
    headers = _ref7.headers;
  var data = [{
    objectId: media === null || media === void 0 ? void 0 : (_media$bucket = media.bucket) === null || _media$bucket === void 0 ? void 0 : _media$bucket.objectId,
    fileName: media === null || media === void 0 ? void 0 : media.name
  }];
  return createHTTP(baseURL, headers).put(UPLOAD_TO_MEDIA, data).then(function (result) {
    if (result.status === 200) {
      var _result$data;
      return successCb({
        response: result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.data[0],
        media: media
      });
    }
    return failureCb(result);
  })["catch"](function (error) {
    var errorMessage = getErrorMessage(error, EMPTY_STRING);
    failureCb({
      media: media,
      errorMessage: errorMessage
    });
  });
};
export var uploadFileToBucket = function uploadFileToBucket(media) {
  var progressCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _noop;
  var successCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _noop;
  var failureCb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _noop;
  var config = arguments.length > 4 ? arguments[4] : undefined;
  return function () {
    if (!media) {
      console.error('Missing media which are required for upload');
      return;
    }
    if (!media.bucket) {
      console.error('Missing presigned url which are required for upload');
      return;
    }
    var url = media.bucket.url;
    var cancelSource = media.cancelSource;
    progressCb({
      media: media,
      progress: 0
    });
    var onProgressUpdate = function onProgressUpdate(progressEvent) {
      var progress = progressEvent.loaded / progressEvent.total * 100;
      progressCb({
        media: media,
        progress: progress
      });
    };
    var data = new Blob([media.file], {
      type: media.file.type
    });
    var axiosConfig = {
      url: url,
      onUploadProgress: onProgressUpdate,
      cancelToken: cancelSource.token
    };

    // eslint-disable-next-line consistent-return
    return createHTTP(url).put(EMPTY_STRING, data, axiosConfig).then(function (result) {
      if (result.status === 200) {
        return generatePresignedURLAfterUpload(successCb, failureCb, media, config);
      }
      return failureCb(result);
    })["catch"](function (error) {
      var errorMessage = getErrorMessage(error, EMPTY_STRING);
      failureCb({
        media: media,
        errorMessage: errorMessage
      });
    });
  };
};
export var getPreSignedUrlBuckets = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(count) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.abrupt("return", Http.get("".concat(GET_PRESIGNED_URL_BUCKETS, "/").concat(count)).then(function (result) {
            return _get(result, 'data.data') || EMPTY_OBJECT;
          })["catch"](function (error) {
            var errorMessage = getErrorMessage(error, EMPTY_STRING);
            toaster(__('Something went wrong. Please Try Again.'), {
              severity: TOASTER_TYPE.ERROR
            });
            return {
              data: null,
              error: errorMessage
            };
          }));
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function getPreSignedUrlBuckets(_x) {
    return _ref8.apply(this, arguments);
  };
}();